<template>
  <div>ReservationMealHistory</div>
</template>

<script>
export default {
  name: 'ReservationMealHistory',
  data() {
    return {

    }
  }
}
</script>
